import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import LoggedInNavBar from '../components/menus/LoggedInNavBar';
import GuestNavBar from '../components/menus/GuestNavBar';

import {
  login, logout, loadProfile, changePassword,
} from '../actions/auth';
import { Shapes } from '../models/entities';
import ProfileNav from '../components/menus/ProfileNav';

class TopMenu extends PureComponent {
  render() {
    const {
      authenticated, login: onLogin, logout: onLogout,
      profile, loadProfile: onLoad, error, clientsById,
      changePassword: onChangePassword,
    } = this.props;

    if (authenticated) {
      return (
        <LoggedInNavBar profile={profile} onLoad={onLoad}>
          <ProfileNav
            profile={profile}
            clientsById={clientsById}
            onLogout={onLogout}
            onChangePassword={onChangePassword}
          />
        </LoggedInNavBar>
      );
    }

    return <GuestNavBar onLogin={onLogin} error={error} />;
  }
}

TopMenu.propTypes = {
  authenticated: PropTypes.bool,
  login: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  loadProfile: PropTypes.func.isRequired,
  changePassword: PropTypes.func.isRequired,
  profile: Shapes.USER,
  clientsById: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    active: PropTypes.bool,
  })),
  error: PropTypes.string,
};

TopMenu.defaultProps = {
  authenticated: false,
  profile: null,
  error: undefined,
  clientsById: {},
};

const mapStateToProps = (state) => {
  const {
    entities: {
      users, clients,
    },
    authenticated, profile,
  } = state;

  return {
    authenticated,
    profile: profile ? users[profile] : null,
    clientsById: clients,
    error: state.error,
  };
};

export default connect(mapStateToProps, {
  login, logout, loadProfile, changePassword,
})(TopMenu);
